import { extractArrayFromQuery } from '../../../utils/query';

export default {
  param: extractArrayFromQuery,
  query: function (values) {
    if (values.length > 0) {
      return {
        $or: values.map(function(value) {
          return {
            participate: {
              1: 'Yes',
              2: 'No',
              3: {
                $null: true
              }
            }[value]
          }
        })
      }
    }
  }
}
